import { COMPARISON_ROWS } from '../data/content';
import SectionHead from './SectionHead';
import { Reveal } from '../lib/motion';

const WASTE = { 'sehr gering': 1, mittel: 3, hoch: 5 };

const WasteMeter = ({ level }) => {
  const n = WASTE[level] ?? 3;
  return (
    <span className="inline-flex items-center gap-2">
      <span className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((k) => (
          <span key={k} className={`h-3 w-1.5 rounded-sm ${k <= n ? (n <= 1 ? 'bg-[#FF6B00]' : 'bg-[#7D8391]') : 'bg-[#282C37]'}`} />
        ))}
      </span>
      <span>{level}</span>
    </span>
  );
};

export default function ComparisonSection() {
  return (
    <section id="vergleich" data-testid="comparison-section" className="chapter">
      <div className="wrap">
        <SectionHead
          n="07"
          eyebrow="Medienvergleich"
          title="Entscheidend ist, was ein Kontakt wert ist – nicht nur, was er kostet."
          testid="comparison-headline"
          lead="Klassische Kanäle sind je Kontakt oft günstig, erreichen aber viele Menschen, die nie Ihre Kunden werden. Der Unterschied liegt in Streuverlust und Nähe zum Kauf."
        />

        <Reveal className="mt-16 overflow-hidden rounded-2xl border border-[#282C37]" data-testid="comparison-table">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[680px] text-left">
              <thead>
                <tr className="bg-[#16181D] font-mono-num text-[10px] uppercase tracking-[0.2em] text-[#7D8391]">
                  <th className="px-6 py-5 font-semibold">Kanal</th>
                  <th className="px-6 py-5 font-semibold">Preis je 1.000 Kontakte</th>
                  <th className="px-6 py-5 font-semibold">Streuverlust</th>
                  <th className="px-6 py-5 font-semibold">Nähe zum Kauf</th>
                </tr>
              </thead>
              <tbody>
                {COMPARISON_ROWS.map((r, i) => (
                  <tr
                    key={r.channel}
                    data-testid={`comparison-row-${i}`}
                    className={`border-t border-[#282C37] transition-colors duration-200 ${r.highlight ? 'bg-[#FF6B00]/10' : 'hover:bg-[#16181D]'}`}
                  >
                    <td className={`px-6 py-5 text-base font-bold ${r.highlight ? 'text-[#FF6B00]' : 'text-white'}`}>{r.channel}</td>
                    <td className="px-6 py-5 font-mono-num text-base text-[#F9FAFB]">{r.price}</td>
                    <td className="px-6 py-5 text-sm text-[#B6BCC8]"><WasteMeter level={r.waste} /></td>
                    <td className="px-6 py-5 text-sm text-[#B6BCC8]">{r.proximity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
        <p className="t-muted mt-5 max-w-[80ch]">
          Preise je 1.000 Kontakte: marktübliche Werte aus Mediadaten und Preislisten 2025, gerundet. Unsere Sichtkontakte sind eine Modellrechnung auf Basis der Einkäufe an der Kasse.
        </p>
      </div>
    </section>
  );
}
